import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { GENERAL_SETTINGS_REQUEST_ASYNC, UPDATE_GENERAL_SETTINGS_REQUEST } from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
        return {
          ...state,
          loader: true,
        }
      case GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case GENERAL_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case GENERAL_SETTINGS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE:
        return { ...state, loader: true }
      case UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS: {
        return { ...state, data: action.payload.data, error: null, loader: false }
      }
      case UPDATE_GENERAL_SETTINGS_REQUEST.ERROR:
        return { ...state, error: action.error, loader: false }
      case UPDATE_GENERAL_SETTINGS_REQUEST.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
